module.exports = __webpack_public_path__ + "static/img/dark.b2948438.svg";